import { render, staticRenderFns } from "./videoplayerSmall.vue?vue&type=template&id=b2b2d002&scoped=true&"
import script from "./videoplayerSmall.vue?vue&type=script&lang=js&"
export * from "./videoplayerSmall.vue?vue&type=script&lang=js&"
import style0 from "./videoplayerSmall.vue?vue&type=style&index=0&id=b2b2d002&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2b2d002",
  null
  
)

component.options.__file = "videoplayerSmall.vue"
export default component.exports